import { treeNodeUtils } from '~/util';
import {
	INIT_DATA,
	ADD_LESSON,
	ADD_TOPIC,
	ADD_QUIZ,
	ADD_QUESTION,
	ADD_QUESTION_ENTITY,
	UPDATE_NODE_TITLE,
} from '~/constants';

// Default state for the data
const defaultState = {
	currentTab: LearnDashData.currentTab && LearnDashData.currentTab,
	tabs: ( LearnDashData.tabs && LearnDashData.tabs ) || '',
	editing: LearnDashData.editing && LearnDashData.editing,
	courses: LearnDashData.courses && LearnDashData.courses,
	lessons: LearnDashData.lessons && LearnDashData.lessons,
	topics: LearnDashData.topics && LearnDashData.topics,
	quizzes: LearnDashData.quizzes && LearnDashData.quizzes,
	labels: LearnDashData.labels && LearnDashData.labels,
	questions: ( LearnDashData.questions && LearnDashData.questions ) || '',
};

/**
 * Initial raw data
 *
 * @param {*} state
 * @param {*} action
 */
export const data = ( state = defaultState, action ) => {
	switch ( action.type ) {
		// Sets the data for each entity.
		case INIT_DATA: {
			return {
				...state,
				[ action.payload.field ]: action.payload.data,
			};
		}

		// Adds a new lesson entity in the raw data
		case ADD_LESSON: {
			const lessons = Object.values( state.lessons );
			lessons.unshift( action.payload );

			return {
				...state,
				lessons,
			};
		}

		// Adds a new topic entity in the raw data
		case ADD_TOPIC: {
			const topics = Object.values( state.topics );
			topics.unshift( action.payload );

			return {
				...state,
				topics,
			};
		}

		// Adds a new quiz entity in the raw data
		case ADD_QUIZ: {
			const quizzes = Object.values( state.quizzes );
			quizzes.unshift( action.payload );

			return {
				...state,
				quizzes,
			};
		}

		// Adds a new question entity in the raw data
		case ADD_QUESTION:
		case ADD_QUESTION_ENTITY: {
			const questions = Object.values( state.questions );
			questions.unshift( action.payload );

			return {
				...state,
				questions,
			};
		}

		// Updates the title for a node
		case UPDATE_NODE_TITLE: {
			if ( action.payload.ID && action.payload.post_title ) {
				const nodeMap = {
					lesson: 'lessons',
					'sfwd-lessons': 'lessons',
					topic: 'topics',
					'sfwd-topic': 'topics',
					quiz: 'quizzes',
					'sfwd-quiz': 'quizzes',
					question: 'questions',
					'sfwd-question': 'questions',
				};

				const stateObject = Object.values(
					state[ nodeMap[ action.payload.type ] ]
				);
				const node = treeNodeUtils.getNodeByKey(
					stateObject,
					action.payload.ID
				);

				if ( node ) {
					node.post_title = action.payload.post_title;
				}

				if ( 'lesson' === action.payload.type ) {
					return {
						...state,
						lessons: stateObject,
					};
				} else if ( 'topic' === action.payload.type ) {
					return {
						...state,
						topics: stateObject,
					};
				} else if ( 'quiz' === action.payload.type ) {
					return {
						...state,
						quizzes: stateObject,
					};
				} else if ( 'question' === action.payload.type ) {
					return {
						...state,
						questions: stateObject,
					};
				}
			}

			return state;
		}

		default:
			return state;
	}
};
